import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchApi } from "Config/fetchApi";
import { handleError } from "Helper";

// Initial state
const initialState = {
  videoPath: {
    datavideoPath: [],
    isLoadingvideoPath: false,
    errorvideoPath: null,
  },
};


// Thunk action for fetching IP Cam Path
export const getvideoPath = createAsyncThunk(
  "video/getvideoPath",
  async ({ videoPath } = {}, { rejectWithValue }) => {
    try {
      const api = fetchApi(); // Menggunakan fetchApi
      const url = `/video/access/${videoPath}?videoPath=${videoPath}`;
      const result = await api.get(url);
      return result?.data;
    } catch (error) {
      handleError(error);
      console.error(error);
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

// Slice definition
const videoPathSlice = createSlice({
  name: "videoPath",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getvideoPath.pending, (state) => {
        state.videoPath.isLoadingvideoPath = true;
        state.videoPath.errorvideoPath = null;
      })
      .addCase(getvideoPath.fulfilled, (state, action) => {
        state.videoPath.isLoadingvideoPath = false;
        state.videoPath.datavideoPath = action.payload || [];
        state.videoPath.errorvideoPath = null;
      })
      .addCase(getvideoPath.rejected, (state, action) => {
        state.videoPath.isLoadingvideoPath = false;
        state.videoPath.errorvideoPath = action.payload;
      });
  },
});

export default videoPathSlice.reducer;
